import apiClient from "./MyClient";


export default{ 

 
    
    getAllTalksByAdmin(){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.get('/api/admin/talks')
    },


    saveTalkToDB(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/admin/save/talk', formData)

    },


    getThisTalk(id){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.get('/api/admin/talk/' + id)

    },


    updateTalk(id, formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/admin/talk/update/' + id, formData) 

    },


    deleteThisTalk(id){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/admin/talk/delete/' + id)

    },


    getAllManagerAccounts(){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.get('/api/admin/managers')

    },


    getAManagerAccountDetails(uuid){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.get('/api/admin/manager/' + uuid)

    },

    addAppAccess(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/add/new/manaager/access/', formData)

    },

    toggleAppAccess(formData, uuid){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/toggle/manager/access/' + uuid, formData)

    },


    updateAppAccess(formData, uuid){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/update/app/access/' + uuid, formData) 

    },

    processExcelFile(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        //for file uploads IMPORTANT
        const config = {
            headers: {
            "content-type": "multipart/form-data", 
            },
        };

        return apiClient.post('/api/manager/upload/users-file/', formData, config) 

    },



    processExcelFileToAddNewEmployeesToSupervisorTeam(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        //for file uploads IMPORTANT
        const config = {
            headers: {
            "content-type": "multipart/form-data", 
            },
        };

        return apiClient.post('/api/manager/upload/new-users-file/to-supervisor-team', formData, config) 
        
    },

    

    deleteAppAccess(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/manager/delete/app-access/', formData) 

    },

    enrollNewUsersOnStandardTalksToAlreadyScheduledTalks(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/manager/standard-talk/enroll/new-users', formData) 

    },


    updateUserInfoService(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/admin/update/user-account', formData) 

    },


    adminAIGenerateTalkService(formData){

        const authStore = localStorage.getItem("authStore"); 
        apiClient.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(authStore).token;

        return apiClient.post('/api/admin/ai/generate-talk', formData) 

    },



    downloadSafetyTalkTextAsPDFService(formData) {

        const authStore = localStorage.getItem("authStore");
        apiClient.defaults.headers.common["Authorization"] =
          "Bearer " + JSON.parse(authStore).token;
    
        //   return apiClient.post("/api/admin/export-pdf/download", formData);
    
        return apiClient.post("/api/admin/export-pdf/download", formData, { responseType: 'blob' });
    
      }, 



      checkEmailListStatusinDBForSuperAdminService(formData){

        const authStore = localStorage.getItem("authStore");
        apiClient.defaults.headers.common["Authorization"] =
          "Bearer " + JSON.parse(authStore).token;
    
          return apiClient.post("/api/admin/check/email-list", formData);
    
      },


      deleteSoftDeletedEmailsForeverService(formData){

        const authStore = localStorage.getItem("authStore");
        apiClient.defaults.headers.common["Authorization"] =
          "Bearer " + JSON.parse(authStore).token;
    
          return apiClient.post("/api/admin/delete/soft-deleted-emails", formData);

      },


      enrollNewSupervisorsOnGroupTalksToAlreadyScheduledTalksService(formData){

        const authStore = localStorage.getItem("authStore");
        apiClient.defaults.headers.common["Authorization"] =
          "Bearer " + JSON.parse(authStore).token;
    
          return apiClient.post("/api/admin/old-talks/enroll/new-supervisors", formData);

      },


      getDataToEnrollNewSupervisorsService(formData){

        const authStore = localStorage.getItem("authStore");
        apiClient.defaults.headers.common["Authorization"] =
          "Bearer " + JSON.parse(authStore).token;
    
          return apiClient.post("/api/admin/get-data/enroll-new-sups", formData);

      },


      sendMasterAccountWelcomeEmailService(formData){ 

        const authStore = localStorage.getItem("authStore");
        apiClient.defaults.headers.common["Authorization"] =
          "Bearer " + JSON.parse(authStore).token;
    
          return apiClient.post("/api/admin/master-account/send-welcome-email", formData);

      }



    


    


  
}